import type { BidComplianceOutcome, ComplianceBucket } from '@/features/bid-compliance/types';

export enum BidComplianceStatus {
  FAILED = -20,
  NOT_STARTED = 0,
  IN_PROGRESS = 10,
  DONE = 20,
}

export const BID_COMPLIANCE_CATEGORIES = [
  'QUALIFICATION_REQUIREMENTS',
  'BID_SUBMISSION_REQUIREMENTS',
  'AWARD_CRITERIA_REQUIREMENTS',
  'COMMERCIAL_BID_REQUIREMENTS',
  'OTHER',
] as const;

export const COMPLIANCE_BUCKETS = ['missing', 'unclear', 'covered'] as const;

export const COMPLIANCE_BUCKET_VARIANT = {
  missing: 'destructive',
  unclear: 'warning',
  covered: 'success',
} as const;

export const COMPLIANCE_BUCKET_TEXT: Record<ComplianceBucket, { en: string; nb: string }> = {
  missing: { en: 'Missing', nb: 'Mangler' },
  unclear: { en: 'Needs review', nb: 'Må gjennomgås' },
  covered: { en: 'Covered', nb: 'Dekket' },
};

export const OUTCOME_BUCKET: Record<BidComplianceOutcome, ComplianceBucket> = {
  UNCOVERED: 'missing',
  CONTRADICTED: 'unclear',
  UNCLEAR_REVIEW: 'unclear',
  COVERED: 'covered',
  PARTIALLY_COVERED: 'unclear',
};
